import { Grid } from '@mui/material'

import { Box, FloraInput, FloraTypography } from '@grupoboticario/flora-react'

import { periodFieldLabelStyle } from '@/components/EventSiteDisplay/styles'
import { PERIOD_START, PERIOD_END, FIELD_DATE, FIELD_TIME } from '@/constants/periodField'

const PeriodField = ({ values, setFieldValue, isReadOnly }) => {
  const handlePeriodChange = (period, field, value) => {
    setFieldValue(period, {
      ...values[period],
      [field]: value
    })
  }

  return (
    <Grid container data-testid="period-field" spacing={2}>
      <Grid item md={6} sm={12} xs={12}>
        <FloraTypography css={periodFieldLabelStyle} fontSize="bodyLargeStandard">
          Início
        </FloraTypography>
      </Grid>

      <Grid item md={6} sm={12} xs={12}>
        <FloraTypography css={periodFieldLabelStyle} fontSize="bodyLargeStandard">
          Fim
        </FloraTypography>
      </Grid>

      <Grid item md={3} sm={6} xs={12}>
        <Box style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <FloraInput
            value={values[PERIOD_START]?.[FIELD_DATE] || ''}
            id="date-start"
            label="Data:"
            onChange={(e) => handlePeriodChange(PERIOD_START, FIELD_DATE, e.target.value)}
            disabled={isReadOnly}
            required
            type="date"
            size="medium"
            data-testid="date-start-input"
          />
        </Box>
      </Grid>
      <Grid item md={3} sm={6} xs={12}>
        <Box style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <FloraInput
            value={values[PERIOD_START]?.[FIELD_TIME] || ''}
            id="time-start"
            label="Hora:"
            onChange={(e) => handlePeriodChange(PERIOD_START, FIELD_TIME, e.target.value)}
            required
            type="time"
            disabled={isReadOnly}
            size="medium"
            data-testid="time-start-input"
          />
        </Box>
      </Grid>

      <Grid item md={3} sm={6} xs={12}>
        <Box style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <FloraInput
            value={values[PERIOD_END]?.[FIELD_DATE] || ''}
            id="date-end"
            label="Data:"
            onChange={(e) => handlePeriodChange(PERIOD_END, FIELD_DATE, e.target.value)}
            required
            type="date"
            disabled={isReadOnly}
            size="medium"
            data-testid="date-end-input"
          />
        </Box>
      </Grid>
      <Grid item md={3} sm={6} xs={12}>
        <Box style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <FloraInput
            value={values[PERIOD_END]?.[FIELD_TIME] || ''}
            id="time-end"
            label="Hora:"
            onChange={(e) => handlePeriodChange(PERIOD_END, FIELD_TIME, e.target.value)}
            required
            type="time"
            disabled={isReadOnly}
            size="medium"
            data-testid="time-end-input"
          />
        </Box>
      </Grid>
    </Grid>
  )
}

export default PeriodField
